import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import parseSearchQuery from "../../helpers/routes/parseSearchQuery";
import {subscribeTopic, unsubscribeTopic} from "../../services/EventServices";
import {REQUEST_SEARCH_TRADE_MARK} from "../../constants/EventConstants";

class FormSearch extends Component {
    state = {
        text: ''
    };

    componentDidMount() {
        this._checkStartup();

        subscribeTopic(REQUEST_SEARCH_TRADE_MARK, this._handleRequestSearch);
    }

    componentWillUnmount() {
        unsubscribeTopic(REQUEST_SEARCH_TRADE_MARK, this._handleRequestSearch);
    }

    _handleRequestSearch = (text) => {
        this.props.onSubmit(text);
    };

    _checkStartup = () => {
        const {term} = parseSearchQuery(this.props.history);

        if (term) {
            this.props.onSubmit(term);
        }
    };

    render() {
        const {text} = this.state;

        return (
            <form className="FormSearch form-inline" onSubmit={this._handleOnSubmit.bind(this)}>
                <input className="form-control"
                       placeholder="Enter some text"
                       onChange={this._handleOnChangeText.bind(this)} value={text}
                       type="text"/>
                <button disabled={!text} className="btn btn-primary" type="submit">Search</button>
            </form>
        );
    }

    _handleOnSubmit(e) {
        e.preventDefault();
        const {text} = this.state;

        if (!text) {
            return;
        }

        this.props.onSubmit(text)
            .then(() => {
                this.setState({
                    text: ""
                });
            });
    }

    _handleOnChangeText(e) {
        const {value} = e.target;

        this.setState({
            text: value
        });
    }
}

FormSearch.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(FormSearch);


// WEBPACK FOOTER //
// ./src/app/home/FormSearch.js